import axios from '@/utils/axios';

// 获取省列表
export function GetProvinceList() {
    return axios({
        url: '/city/province/list',
        method: 'get',
        params: { },
    });
}

// 获取市列表
export function GetCityList(provinceId) {
    return axios({
        url: '/city/city/list',
        method: 'get',
        params: { provinceId },
    });
}

// 获取省列表
export function GetZoneList(cityId) {
    return axios({
        url: '/city/zone/list',
        method: 'get',
        params: { cityId },
    });
}